import { Injectable, signal } from '@angular/core';

export type ScheduleBlock = { blockNo: number; time: string; scheduleMw: number | null; actualCapacityMw: number | null };
export type ScheduleUploadRecord = {
  id: string; generatorId: number; unitId: number | null; scheduleType: string; revisionNo: string;
  scheduleDate: string; fileName: string; fileSize: number; uploadedAt: string; scheduleBlocks: ScheduleBlock[];
};

const STORAGE_KEY = 'mh-re-schedule-uploads';

@Injectable({ providedIn: 'root' })
export class ScheduleUploadStoreService {
  readonly records = signal<ScheduleUploadRecord[]>(this.read());

  save(record: ScheduleUploadRecord): ScheduleUploadRecord {
    const index = this.records().findIndex((item) => item.generatorId === record.generatorId && item.unitId === record.unitId && item.scheduleDate === record.scheduleDate && item.revisionNo === record.revisionNo);
    const saved = index === -1 ? record : { ...record, id: this.records()[index].id };
    const next = index === -1 ? [saved, ...this.records()] : this.records().map((item, itemIndex) => itemIndex === index ? saved : item);
    this.records.set(next);
    if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return saved;
  }

  refresh(): void { this.records.set(this.read()); }
  getById(id: string): ScheduleUploadRecord | null { return this.records().find((record) => record.id === id) ?? null; }
  getByGenerator(generatorId: number): ScheduleUploadRecord[] { return this.records().filter((record) => record.generatorId === generatorId); }
  getByDate(scheduleDate: string): ScheduleUploadRecord[] { return this.records().filter((record) => record.scheduleDate === scheduleDate); }
  getByRevision(revisionNo: string): ScheduleUploadRecord[] { return this.records().filter((record) => record.revisionNo === revisionNo); }
  update(id: string, changes: Partial<Omit<ScheduleUploadRecord, 'id'>>): ScheduleUploadRecord | null {
    const current = this.getById(id);
    return current ? this.save({ ...current, ...changes }) : null;
  }

  private read(): ScheduleUploadRecord[] {
    try { return typeof localStorage === 'undefined' ? [] : JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as ScheduleUploadRecord[]; }
    catch { return []; }
  }
}
